/**
 * CloudVmsApi factory function
 */

import { AuthenticatedRequestor } from '@solink/vd-data-layer/api-clients/shared/AuthenticatedRequestor';
import { CloudVmsApi as CloudVmsApiClient } from '@solink/vd-data-layer/api-clients/vms/cloud-vms';

import settings from '@solinkcorp/settings';
import { REQUEST_TIMEOUT } from 'vd-constants';
import AuthService from '../models/AuthService';

/**
 * Create a new CloudVmsApi client with the current token
 * @returns {CloudVmsApi}
 */
export default function CloudVmsApi() {
  const authToken = AuthService.authToken;
  /*
   * Sending the custom solink header, causes requests to be preflighted
   * CloudVMS Endpoints do NOT handle CORS, so sending the custom header leads to a CORS error
   */
  return new CloudVmsApiClient(
    new AuthenticatedRequestor(settings.cloud_vms_host, REQUEST_TIMEOUT, authToken, false),
    settings.cloud_front_vms_host,
  );
}
